import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import { Bot } from 'lucide-react';
import { useState } from 'react';

export const ChatSettings = () => {
  const [enabled, setEnabled] = useState(true);

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center gap-2">
          <Bot className="w-5 h-5 text-primary" />
          <CardTitle>Chat med Kai</CardTitle>
        </div>
        <CardDescription>
          Konfigurer AI-chat funksjonalitet i artikler
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <Label htmlFor="chat-enabled">Aktivert</Label>
          <Switch
            id="chat-enabled"
            checked={enabled}
            onCheckedChange={setEnabled}
          />
        </div>

        <div className="space-y-2">
          <Label>Persona og tone</Label>
          <p className="text-sm text-muted-foreground">
            Tilpass hvordan Kai kommuniserer med lesere i chat-funksjonen.
          </p>
        </div>

        <div className="pt-4 border-t">
          <Button>Lagre innstillinger</Button>
        </div>
      </CardContent>
    </Card>
  );
};
